import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, Loader2, Layers } from 'lucide-react';
import { PublicLayout } from '../../app/layouts/PublicLayout';
import { fetchPublicCourses, formatPrice } from '../../features/courses/api/courses';
import type { Course } from '../../types';
import { COURSE } from '../../constants/testIds';

export default function CourseListPage() {
  const [courses, setCourses] = useState<Course[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPublicCourses()
      .then(setCourses)
      .finally(() => setLoading(false));
  }, []);

  return (
    <PublicLayout>
      <div className="mb-10">
        <p className="text-xs uppercase tracking-[0.2em] text-cyan-400 mb-2">E-Course</p>
        <h1 className="text-4xl sm:text-5xl tracking-tight font-light text-white">Katalog Course</h1>
        <p className="text-white/60 mt-3 max-w-2xl">
          Tingkatkan skill trading Anda bersama Cuantrader Community. Pilih course yang sesuai dengan level Anda.
        </p>
      </div>

      {loading ? (
        <div className="flex justify-center py-20">
          <Loader2 className="w-8 h-8 text-cyan-400 animate-spin" strokeWidth={1.5} />
        </div>
      ) : courses.length === 0 ? (
        <div className="text-white/50 py-20 text-center">Belum ada course yang tersedia.</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid={COURSE.publicList}>
          {courses.map((c) => (
            <div
              key={c.id}
              data-testid={COURSE.publicCard}
              className="bg-white/[0.02] backdrop-blur-xl border border-white/10 rounded-2xl overflow-hidden flex flex-col transition-colors hover:border-cyan-400/30"
            >
              <div className="h-40 bg-gradient-to-br from-cyan-400/20 to-transparent flex items-center justify-center overflow-hidden">
                {c.thumbnail_url ? (
                  <img src={c.thumbnail_url} alt={c.title} className="w-full h-full object-cover" />
                ) : (
                  <BookOpen className="w-10 h-10 text-cyan-400/60" strokeWidth={1.5} />
                )}
              </div>
              <div className="p-6 flex flex-col flex-1">
                <span className="text-[10px] uppercase tracking-[0.2em] text-cyan-400 mb-2">{c.category}</span>
                <h3 className="text-lg font-medium text-white mb-2">{c.title}</h3>
                <p className="text-sm text-white/60 line-clamp-3 flex-1">{c.description}</p>
                <div className="flex items-center gap-2 text-xs text-white/40 mt-4">
                  <Layers className="w-4 h-4" strokeWidth={1.5} />
                  {c.lesson_count ?? 0} lesson
                </div>
                <div className="flex items-center justify-between mt-4">
                  <span className="text-cyan-400 font-medium">{formatPrice(c.price, c.currency)}</span>
                  <Link
                    to={`/courses/${c.slug}`}
                    data-testid={COURSE.viewDetail}
                    className="bg-white/5 text-white border border-white/10 font-medium px-4 py-2 rounded-lg transition-colors hover:bg-white/10 hover:text-cyan-400 text-sm"
                  >
                    Lihat Detail
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </PublicLayout>
  );
}
